import React from 'react';

import Sponsor from './Sponsor';


export default class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            previous: -1,
        };
    }

    componentDidMount() {
        this.state.mounted = true;
        this.state.intervalId = setInterval(this.handleImageSwitch.bind(this), 3000);
    }

    componentWillUnmount() {
        this.state.mounted = false;
        clearInterval(this.state.intervalId);
    }

    render() {
        var sponsors = this.props.sponsors.map((sponsor, i) => {
            var className;
            if (i == this.state.previous) className = 'previous';
            else if (i == this.state.current) className = 'front';
            return <Sponsor eventId={this.props.eventId} sponsor={sponsor} key={sponsor.id} className={className} />;
        });
        return <div className="carousel">{sponsors}</div>;
    }

    handleImageSwitch() {
        var current = this.state.current;
        var next = current + 1;
        if (next >= this.props.sponsors.length) {
            next = 0;
        }
        this.setState({current: next, previous: current});
        setTimeout(() => {
            if (this.state.mounted) {
                this.setState({previous: -1});
            }
        }, 600);
    }
}
